module.exports = __webpack_public_path__ + "static/media/token7.5c4d73bc.png";